// Notifications.jsx
import React, { useState } from 'react';
import MyMasterLayout from './../../../layouts/Mentor/MyMasterlayout';
import "./../../../assets/css/mentor/mentordashboard/Notifications.css";

const Notifications = () => {
  // Dummy notifications data - matching database fields
  const [notifications] = useState([
    {
      id: 1,
      user_id: 101,
      type: 'request',
      message: 'Ali Khan sent you a new mentorship request',
      read_at: null,
      created_at: '2025-02-05 10:30:00'
    },
    {
      id: 2,
      user_id: 102,
      type: 'message',
      message: 'Sara Ahmed sent you a message: "Sir, assignment ka doubt hai"',
      read_at: null,
      created_at: '2025-02-05 07:15:00'
    },
    {
      id: 3,
      user_id: 103,
      type: 'submission',
      message: 'Hassan Ali submitted assignment: React Components',
      read_at: '2025-02-04 14:20:00',
      created_at: '2025-02-04 09:00:00'
    },
    {
      id: 4,
      user_id: 104,
      type: 'rating',
      message: 'Ayesha Malik rated your session 5 stars',
      read_at: '2025-02-04 16:00:00',
      created_at: '2025-02-04 08:45:00'
    },
    {
      id: 5,
      user_id: 105,
      type: 'session',
      message: 'New session scheduled with Usman Raza for tomorrow at 3 PM',
      read_at: null,
      created_at: '2025-02-03 11:30:00'
    },
    {
      id: 6,
      user_id: 101,
      type: 'reminder',
      message: 'Reminder: Review pending mentorship requests (3 pending)',
      read_at: null,
      created_at: '2025-02-03 09:00:00'
    },
    {
      id: 7,
      user_id: 106,
      type: 'achievement',
      message: 'Congratulations! You reached 100 completed sessions',
      read_at: '2025-02-02 18:30:00',
      created_at: '2025-02-02 10:00:00'
    },
    {
      id: 8,
      user_id: 107,
      type: 'question',
      message: 'Fatima Khan asked a question in Web Development course',
      read_at: '2025-02-02 15:00:00',
      created_at: '2025-02-02 12:30:00'
    },
    {
      id: 9,
      user_id: 108,
      type: 'deadline',
      message: 'Assignment deadline approaching: JavaScript Basics (Due in 2 days)',
      read_at: null,
      created_at: '2025-02-01 08:00:00'
    },
    {
      id: 10,
      user_id: 109,
      type: 'favorite',
      message: 'Ahmed Raza added you to their favorite mentors',
      read_at: '2025-01-31 19:00:00',
      created_at: '2025-01-31 14:00:00'
    }
  ]);

  // Get icon based on type
  const getIcon = (type) => {
    switch(type) {
      case 'request': return 'bi bi-person-plus-fill';
      case 'message': return 'bi bi-chat-dots-fill';
      case 'submission': return 'bi bi-file-earmark-check-fill';
      case 'rating': return 'bi bi-star-fill';
      case 'session': return 'bi bi-calendar-check-fill';
      case 'reminder': return 'bi bi-bell-fill';
      case 'achievement': return 'bi bi-trophy-fill';
      case 'question': return 'bi bi-question-circle-fill';
      case 'deadline': return 'bi bi-exclamation-triangle-fill';
      case 'favorite': return 'bi bi-heart-fill';
      default: return 'bi bi-info-circle-fill';
    }
  };

  // Get icon color based on type
  const getIconColor = (type) => {
    switch(type) {
      case 'request': return '#3b82f6';
      case 'message': return '#8b5cf6';
      case 'submission': return '#10b981';
      case 'rating': return '#f59e0b';
      case 'session': return '#06b6d4';
      case 'reminder': return '#ef4444';
      case 'achievement': return '#f59e0b';
      case 'question': return '#6366f1';
      case 'deadline': return '#ef4444';
      case 'favorite': return '#ec4899';
      default: return '#6b7280';
    }
  };

  // Format date to relative time
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) return `${diffMins} minutes ago`;
    if (diffHours < 24) return `${diffHours} hours ago`;
    if (diffDays === 1) return '1 day ago';
    return `${diffDays} days ago`;
  };

  // Count unread notifications
  const unreadCount = notifications.filter(n => n.read_at === null).length;

  return (
    <MyMasterLayout>
      <div className="notifications-content">
        <div className="notifications-header">
          <h2 className="notifications-title">
            <i className="bi bi-bell-fill"></i> All Notifications
          </h2>
          <div className="notifications-stats">
            <span className="notification-count">{notifications.length} total</span>
            {unreadCount > 0 && (
              <span className="unread-badge">{unreadCount} unread</span>
            )}
          </div>
        </div>

        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th className="text-center" style={{ width: '80px' }}>Type</th>
                <th>Message</th>
                <th style={{ width: '150px' }}>Date</th>
                <th className="text-center" style={{ width: '100px' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {notifications.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center py-4 text-muted">
                    No notifications found
                  </td>
                </tr>
              ) : (
                notifications.map(notification => (
                  <tr 
                    key={notification.id}
                    className={notification.read_at === null ? 'unread-row' : ''}
                  >
                    <td className="text-center">
                      <div 
                        className="notification-icon" 
                        style={{ color: getIconColor(notification.type) }}
                      >
                        <i className={getIcon(notification.type)}></i>
                      </div>
                    </td>
                    <td className="notification-message">
                      {notification.message}
                    </td>
                    <td className="notification-date">
                      {formatDate(notification.created_at)}
                    </td>
                    <td className="text-center">
                      {notification.read_at === null ? (
                        <span className="badge badge-unread">Unread</span>
                      ) : (
                        <span className="badge badge-read">Read</span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </MyMasterLayout>
  );
};

export default Notifications;